// BEGIN
var WDN = WDN || {};

WDN.StoreHandler = (function() {
  var list = [];

  /*
  
  STORECONFIG array

  -  Used to format input for new #Store function
  Required input for new Store is an object
  We send in an array, in which we take the values from, and
  remap with the following config

  ### Example:

  @input ['domain.com', 'USD', 'US]
   
  @output {
    host: 'domain.com',
    currency: 'US'
    [...]
  }
  */
  
  var storeConfig = ['host', 'currency', 'countryList'];

  var mapListToConfigObject = function(args, formatList) {
    var storeSettings = {};
    
    if (!formatList) {
      formatList = storeConfig; 
    }

    args.forEach(function(item, index) {
      storeSettings[formatList[index]] = item;
    });

    return storeSettings;
  }


  var findStoreByField = function(field, value) {
    field = field.replace('country', 'countryList');
    
    var search = function(field, value) {
      return list.filter(function(store) {
        if (store[field].indexOf(value) > -1) {
          return true;
        }
      })[0];
    }

    // If we don't get any matches, let's see if a default is provided
    var match = search(field, value);

    // If we still don't have any matches, return false
    if (!match) {
      return false;
    }

    return match;
  }


  var add = function(args) {
    new Store(mapListToConfigObject(args, storeConfig));
  }


  var Store = function(settings) {
    this.host = settings.host;
    this.currency = settings.currency;
    this.countryList = settings.countryList;
    list.push(this);
  }
  
  var handlers = {
    add: add,
    list: function() {
      return list; 
    },
    find: findStoreByField
  }
  
  return function(action, ...args) {
   return handlers[action](...args);
  }
})();
// END



WDN.StoreRedirection = (function() {

  var Stores = WDN.StoreHandler;
  var configSet = false;

  var config = {
    DEVMODE: false, // log instead of redirecting
    send_countrycode: true, // Send countrycode as param in redirect URL
    send_path: true, // Use deeplinking
    send_all_params: true, // Send all params (you can still ban specific ones)
    params_allowed: false, // If send_all_params is DISABLED, specify which params to send along
    params_banned: false, // List of params banned, only applicable if send_all_params are ENABLED
    country_code_param_name: 'userLocation', // rename the param that holds the country code
    fallback_to_default: true, // use default config if no res is found (only works if a default is supplied)
    replace_or_redirect: "REPLACE" // REPLACE URL so user can't go back or Redirect which allow user to go back
  }
  
  var setConfig = function(user_config) {
    // Ignore if already set...
    if (configSet) {
      throw "StoreRedirection config already set once...";
      return;
    }

    configSet = true;
    config = Object.assign(config, user_config);
  }
  
  
  var buildURI = function(host) {
    var base = 'https://' + host;

    var currentPath = window.location.pathname;

    if (currentPath === '/' || !config.send_path) {
      currentPath = ''; 
    }

    return base += currentPath;
  }
  
  var buildParams = function(country_code) {
    var currentParams = new URLSearchParams(window.location.search);
    var userCountryLocation = country_code;
    
    // Don't send params 
    // Setup logic
      if (config.params_banned && typeof config.params_banned.length !== 'undefined') {
        config.params_banned.forEach(function(item) {
          currentParams.delete(item);
        });
      }

    if (!config.send_all_params) {
      if (config.params_allowed && typeof config.params_allowed.length !== 'undefined') {
        for (var item of currentParams.entries()) {
          if (config.params_allowed.indexOf(item[0]) == -1) {
            currentParams.delete(item[0]);
          }
        }
      } else {
        currentParams =  new URLSearchParams();
      }
    }
    
    if (config.send_countrycode && userCountryLocation && userCountryLocation !== 'DEFAULT') {
      currentParams.set(config.country_code_param_name, userCountryLocation);
    }
    
    return '?' + currentParams.toString();
  }
  
  
  var findStore = function(country_code) {
   if (!country_code) {
      country_code = 'DEFAULT';
    }
    
    var storeMatch = Stores("find", "country", country_code);
    
    if (!storeMatch && config.fallback_to_default) {
     storeMatch = Stores("find", "country", 'DEFAULT');
    }
    
    return storeMatch;
  }

  
  // Setup redirections
  var redirect = function(country_code) {
    var storeMatch = findStore(country_code);
    
    if (!storeMatch) {
      throw "No storeMatch was found. Consider enabling setting fallback to DEFAULT store...";
      return;
    }
    
    var redirectURI = buildURI(storeMatch.host).concat(buildParams(country_code));

    if (config.DEVMODE) {
      console.log(redirectURI);
    } else {
      if (config.replace_or_redirect == 'REDIRECT') {
        window.location.href(redirectURI);  
      } else {
        window.location.replace(redirectURI);
      }
    }
  }
  
  var add = function(args) {
    // This here is basically just a pre-function
    // that allows us to pass in multiple stores at once
    // by passing in an array
    if (typeof args.length !== 'undefined') {
      args.forEach(function(store_config) {
        Stores("add", store_config); 
      });
      
      return;
    }
    
    // If not an array, add it as single
	Stores("add", args);
  }
  
  
  var handlers = {
    redirect: redirect,
    config: setConfig,
    add: add
  }
  
  
  return function(action, ...args) {
    return handlers[action](...args);
  }
})();


// Configure settings
// Uses default settings
// Pass in object to configure
WDN.StoreRedirection("config");

// To use DEV mode (non-redirecting version, simply pass DEVMODE: true)
// ### WDN.StoreRedirection('config', { DEVMODE: true });


// Setup redirection module
(function() {
  WDN.StoreRedirection("add", [
    ['dk.byic.com', 'DKK', ['DK']],
    ['se.byic.com', 'SEK', ['SE']],
    ['no.byic.com', 'NOK', ['NO']],
    ['nl.byic.com', 'EUR', ['NL']],
    ['de.byic.com', 'EUR', ['DE', 'AT']],
    ['en.byic.com', 'EUR', ['DEFAULT']]
  ]);

})();


WDN.Storage = (function() {
    var defaultConfig = {
      type: 'local',
      onlyJSON: false,
      namespace: ''
    }

    var getLocalConfig = function() {
      return Object.assign({}, defaultConfig); 
    }

    var StorageReader = function(config) {
      this.config = Object.assign(getLocalConfig(), config);

      this.storer = function(name, value) {
        if (!value || !name) { return false; }

        name = this.config.namespace + name;

        if (this.config.type && this.config.type === 'session') {
          sessionStorage.setItem(name, value);
        } else {
          localStorage.setItem(name, value);
        }

        this.notify('set', name, value);
      }

      this.loader = function(name) {
        if (!name) { return false; }

        name = this.config.namespace + name;

        var value = localStorage.getItem(name);

        if (this.config.type && this.config.type === 'session') {
          value = sessionStorage.getItem(name);
        }

        return value;
      }
      
      
      this.removeItem = function(name) {
        if (!name) { return; }

        if (this.config.type && this.config.type === 'session') {
          sessionStorage.removeItem(name);
        } else {
          localStorage.removeItem(name);
        }
      }

      // notifier
      this.onChange = {};

      this.notify = function(event_name, name, value) {
        if (event_name == 'set') {
          if (this.onChange.set) {
            this.onChange.set(name, value);
          }
        }
      }

      this.on = function(event_name, callback) {
        this.onChange[event_name] = callback; 
      }


      this.set = function(name, value) {
        if (!value) { return false; }

        this.storer(name, value);
      }


      this.get = function(name) {
        if (!name) { return false; }

        return this.loader(name);
      }

      this.remove = function(name) {
        name = this.config.namespace + name;

        if (this.config.type && this.config.type === 'session') {
          sessionStorage.removeItem(name);
        } else {
          localStorage.removeItem(name);
        }
      }


      this.getAsJSON = function(name) {
        return JSON.parse(this.loader(name));
      }

      this.getJSON = function(name) {
        return this.getAsJSON(name);
      }

      this.setAsJSON = function(name, value) {
        this.storer(name, JSON.stringify(value));
        return this.getJSON(name);
      }

      this.setJSON = function(name, value) {
        return this.setAsJSON(name, value);
      }

      if (this.config.onlyJSON) {
        this.get = this.getJSON;
        this.set = this.setJSON;
      }

      // Alias list
      this.save = this.set;
      this.load = this.get;
      this.read = this.get;
      this.clear = this.remove;
    }

    return StorageReader;

})();
 

var userCountryPreference = new WDN.Storage({
  onlyJSON: true,
  type: 'session',
  namespace: '__userPreferenceLocation'
});



if (typeof WDN.UserCountry === "undefined") {
  WDN.UserCountry = (function () {

    var key = "wCN3MawhB2UoGCO";

    var Config = {
      endpoint: "https://pro.ip-api.com/json/?fields=49154&key=" + key,
    };

    var get = function (callback) {
      var endpoint = Config.endpoint;
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          var response = JSON.parse(this.responseText);
          if (response.status === "success") {
            if (typeof callback === "function") {
              callback(response.countryCode);
            }
            return;
          }
        }
      };
      xhr.open("GET", endpoint, true);
      xhr.send();
    };

    return {
      get: get,
    };
  })();
}


WDN.redirectUser = function() {
  /* 

read preference

 if no preference [done]
   get user location [done]
   save preference [done]
   use prefernece, and find store
   redirect redirect to store

  else
   use preference, and find store
   redirect to store

*/

  var userCountryCode = userCountryPreference.read('country');
  
  if (!userCountryCode) {
    WDN.UserCountry.get(function(country_code) {
      if (country_code) {
        userCountryPreference.save('country', country_code);
      }
      
      WDN.StoreRedirection("redirect", country_code);
    });
  } else {
    WDN.StoreRedirection("redirect", userCountryPreference.read('country'));
  }
}


WDN.redirectUser();